import styled from 'styled-components';

export const StepperChildren = styled.div`
  display: none;
`;
